import constants from '../constants.js';

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly = {
  displayName: 'Specified Passenger Types Only',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.SpecifiedPassengerTypesOnly',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType = {
  displayName: 'CabinType',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.CabinType',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares = {
  displayName: 'Private Fares',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.PrivateFares',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes = {
  displayName: 'Passenger Type Codes',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.PassengerTypes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes = {
  displayName: 'Rate Codes (Corporate Code/Snap Code)',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.RateCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass = {
  displayName: 'Fare Class',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.FareClass',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItem = {
  displayName: 'Item',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass, AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes, AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes, AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares, AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'airCarrierGDSFarSetItem',
  canDelete: true
};

const AirlineCarrierFareGdsSettingsFaresItemFareData = {
  displayName: 'GDS Fare Settings',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareGdsSettingsFaresItemFareDataItem,
  gridCols:
    [{name: 'FareClass', key: 'FareClass'},
      {name: 'RateCodes', key: 'RateCodes'},
      {name: 'PassengerTypes', key: 'PassengerTypes'},
      {name: 'PrivateFares', key: 'PrivateFares'},
      {name: 'CabinType', key: 'CabinType'}]
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes = {
  displayName: 'Excluded Tax Codes',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.ExcludedTaxCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType = {
  displayName: 'Search Type',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.SearchType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'GdsFareSearchSearchType'
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType = {
  displayName: 'Search Group Type',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.SearchGroupType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'GdsFareSearchGroupType'
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries = {
  displayName: 'Countries',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesCountryFareClassFareBasisCodes = {
  displayName: 'Fare Basis Codes',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.FareBasisCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesCountryFareClassBookingCodes = {
  displayName: 'Booking Codes',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.BookingCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesCountryFareClassBrandName = {
  displayName: 'Brand Name',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.BrandName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareClassesCountryFareClassCountries = {
  displayName: 'Countries',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItem = {
  displayName: 'Item',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes, AirlineCarrierFareGdsSettingsFaresItemFareData],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'airGdsFareItem',
  canDelete: true
};

const AirlineCarrierFareClassesCountryFareClassItem = {
  displayName: 'Item',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareClassesCountryFareClassCountries, AirlineCarrierFareClassesCountryFareClassBrandName, AirlineCarrierFareClassesCountryFareClassBookingCodes, AirlineCarrierFareClassesCountryFareClassFareBasisCodes],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'AirFareClsCuFareClsItem',
  canDelete: true
};

const AirlineCarrierFareGdsSettingsFares = {
  displayName: 'Fares',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareGdsSettingsFaresItem,
  gridCols:
    [{name: 'Countries', key: 'Countries'},
      {name: 'SearchGroupType', key: 'SearchGroupType'},
      {name: 'SearchType', key: 'SearchType'},
      {name: 'ExcludedTaxCodes', key: 'ExcludedTaxCodes'}]
};

const AirlineCarrierFareGdsSettingsPreferredCountries = {
  displayName: 'Preferred Country Pairs',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.PreferredCountries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsName = {
  displayName: 'Name',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareClassesCountryFareClass = {
  displayName: 'Country Fare Class',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareClassesCountryFareClassItem,
  gridCols:
    [{name: 'Countries', key: 'Countries'},
      {name: 'Brand Name', key: 'BrandName'},
      {name: 'BookingCodes', key: 'BookingCodes'},
      {name: 'FareBasisCodes', key: 'FareBasisCodes'}]
};

const AirlineCarrierFareClassesGroupType = {
  displayName: 'Group Type',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.GroupType',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareClassesFareBasisCodes = {
  displayName: 'Fare Basis Codes',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.FareBasisCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesRefundableRestriction = {
  displayName: 'Refundable Restriction',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.RefundableRestriction',
  displayAs: constants.DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
  booleanRestrictionFilter: 'refundableRestrictionDisplay',
  required: false
};

const AirlineCarrierFareClassesBookingCodes = {
  displayName: 'Booking Codes',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.BookingCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesBrandName = {
  displayName: 'Brand Name',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.BrandName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareClassesTitle = {
  displayName: 'Title',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierCountryCheckInUrl = {
  displayName: 'Check-in Url',
  dataAt: 'CountryData.$AirCountryDataItem.CheckInUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierCountryDataCountry = {
  displayName: 'Country Data',
  dataAt: 'CountryData.$AirCountryDataItem.Country',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareGdsSettingsItem = {
  displayName: 'Item',
  dataAt: 'GdsSettings.$AirFareGdsSetItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareGdsSettingsName, AirlineCarrierFareGdsSettingsPreferredCountries, AirlineCarrierFareGdsSettingsFares],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'AirFareGdsSetItem',
  canDelete: true
};

const AirlineCarrierFareClassesGridItem = {
  displayName: 'Fare Class',
  dataAt: 'FareClasses.$AirCarrierFaClassItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareClassesTitle, AirlineCarrierFareClassesBrandName, AirlineCarrierFareClassesBookingCodes, AirlineCarrierFareClassesFareBasisCodes, AirlineCarrierFareClassesRefundableRestriction, AirlineCarrierFareClassesGroupType, AirlineCarrierFareClassesCountryFareClass],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'AirCarrierFaClassItem',
  canDelete: true
};

const AirlineCarrierCountryDataGridItem = {
  displayName: 'Country Data',
  dataAt: 'CountryData.$AirCountryDataItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierCountryDataCountry, AirlineCarrierCountryCheckInUrl],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'AirCountryDataItem',
  canDelete: true
};

const AirlineCarrierModifiedOn = {
  displayName: 'Modified On',
  dataAt: 'ModifiedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirlineCarrierModifiedBy = {
  displayName: 'Modified By',
  dataAt: 'ModifiedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirlineCarrierCreatedOn = {
  displayName: 'Created On',
  dataAt: 'CreatedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirlineCarrierCreatedBy = {
  displayName: 'Created By',
  dataAt: 'CreatedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirlineCarrierPartnerAirlines = {
  displayName: 'Partner Airlines',
  dataAt: 'PartnerAirlines',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierLoyaltyPartnershipsSegmentSpecific = {
  displayName: 'Segment Specific',
  dataAt: 'LoyaltyPartnerships.$LoyaltyPartnershipItem.SegmentSpecific',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirlineCarrierLoyaltyPartnershipsPartnerCode = {
  displayName: 'Partner Code',
  dataAt: 'LoyaltyPartnerships.$LoyaltyPartnershipItem.PartnerCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierLoyaltyPartnershipsItem = {
  displayName: 'Loyalty Partnerships',
  dataAt: 'LoyaltyPartnerships.$LoyaltyPartnershipItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierLoyaltyPartnershipsPartnerCode, AirlineCarrierLoyaltyPartnershipsSegmentSpecific],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'LoyaltyPartnershipItem',
  canDelete: true
};

const AirlineCarrierLoyaltyPartnerships = {
  displayName: 'Loyalty Partnerships',
  dataAt: 'LoyaltyPartnerships',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierLoyaltyPartnershipsItem,
  gridCols:
    [{name: 'Partner Code', key: 'PartnerCode'},
      {name: 'Segment Specific', key: 'SegmentSpecific'}]
};

const AirlineCarrierFareRulesDocument = {
  displayName: 'Fare Rules Document',
  dataAt: 'FareRulesDocument',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'FlightFareRule',
  uploadType: 'pdf'
};

const AirlineCarrierFareGdsSettings = {
  displayName: 'GDS Fare Settings',
  dataAt: 'GdsSettings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareGdsSettingsItem,
  gridCols:
    [{name: 'Name', key: 'Name'},
      {name: 'Preferred Countries', key: 'PreferredCountries'}]
};

const AirlineCarrierBrandsBrandItemBrandId = {
  displayName: 'Brand Id',
  dataAt: 'Brands.$BrandItem.BrandId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Brand Id supports Regular Expressions. Regular Expressions must contain ^ or $, otherwise will be treated as not a Regular Expression."
};

const AirlineCarrierBrandsBrandItemFareClass = {
  displayName: 'Fare Class',
  dataAt: 'Brands.$BrandItem.FareClass',
  displayAs: constants.DISPLAY_AS.FARE_CLASS_TYPE_SELECT,
  required: false
};

const AirlineCarrierBrandsBrandItemIsBasic = {
  displayName: 'Basic',
  dataAt: 'Brands.$BrandItem.IsBasic',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};
const AirlineCarrierBrandsBrandItemIsRefundable = {
  displayName: 'Refundable',
  dataAt: 'Brands.$BrandItem.IsRefundable',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};
const AirlineCarrierBrandsBrandItem = {
  displayName: 'Brand',
  dataAt: 'Brands.$BrandItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierBrandsBrandItemBrandId, AirlineCarrierBrandsBrandItemFareClass, AirlineCarrierBrandsBrandItemIsBasic,AirlineCarrierBrandsBrandItemIsRefundable],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'BrandItem',
  canDelete: true
};

const AirlineCarrierBrands = {
  displayName: 'Brands',
  dataAt: 'Brands',
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: AirlineCarrierBrandsBrandItem,
  gridCols:
    [{name: 'Brand Id', key: 'BrandId'},
      {name: 'Basic', key: 'IsBasic'},
      {name: 'Refundable', key: 'IsRefundable'},
      {name: 'FareClass', key: 'FareClass'}]
};

const AirlineCarrierFareClasses = {
  displayName: 'Fare Classes',
  dataAt: 'FareClasses',
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: AirlineCarrierFareClassesGridItem,
  gridCols:
    [{name: 'Title', key: 'Title'},
      {name: 'Brand Name', key: 'BrandName'},
      {name: 'Group Type', key: 'GroupType'},
      {name: 'Booking Codes', key: 'BookingCodes'},
      {name: 'Fare Basis Codes', key: 'FareBasisCodes'}]
};

const AirlineCarrierCountryData = {
  displayName: 'Country Data',
  dataAt: 'CountryData',
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: AirlineCarrierCountryDataGridItem,
  gridCols:
    [{name: 'Country', key: 'Country'},
      {name: 'Check-in Url', key: 'CheckInUrl'}]
};

const AirlineCarrierMediumImageUrl = {
  displayName: 'Medium Image Url',
  dataAt: 'MediumImageUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'FlightCarrier',
  uploadType: 'image'
};

const AirlineCarrierCarrierLogoUrl = {
  displayName: 'Carrier Logo Url',
  dataAt: 'CarrierLogoUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'FlightCarrier',
  uploadType: 'image'
};

const AirlineCarrierBookableFlightNumbers = {
  displayName: 'Bookable Flight Numbers',
  dataAt: 'BookableFlightNumbers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierCheckInUrl = {
  displayName: 'Check-in Url',
  dataAt: 'CheckInUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierId = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarriersAdminPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Admin',
  children: [AirlineCarrierCreatedBy, AirlineCarrierCreatedOn, AirlineCarrierModifiedBy, AirlineCarrierModifiedOn]
};

const AirlineCarrierInternationalFlightNumbers = {
  displayName: "International Flight Numbers",
  dataAt: "InternationalFlightNumbers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierEnableDynamicFareClassification = {
  displayName: 'Enable Dynamic Fare Bucketing',
  dataAt: 'EnableDynamicFareClassification',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirlineCarrierEnableMultipleFaresPerFareClass = {
  displayName: 'Enable Multiple Fares Per Fare Class',
  dataAt: 'EnableMultipleFaresPerFareClass',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirlineCarrierTitle = {
  displayName: 'Title',
  dataAt: 'Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierCode = {displayName: 'Code', dataAt: 'Code', displayAs: constants.DISPLAY_AS.TEXT_INPUT};

const AirlineCarriersInfoPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Info',
  children: [AirlineCarrierEnableDynamicFareClassification, AirlineCarrierEnableMultipleFaresPerFareClass, AirlineCarrierId, AirlineCarrierTitle, AirlineCarrierCode, AirlineCarrierCheckInUrl, AirlineCarrierBookableFlightNumbers, AirlineCarrierInternationalFlightNumbers, AirlineCarrierCarrierLogoUrl, AirlineCarrierMediumImageUrl, AirlineCarrierCountryData, AirlineCarrierBrands, AirlineCarrierFareClasses, AirlineCarrierFareGdsSettings, AirlineCarrierFareRulesDocument, AirlineCarrierPartnerAirlines, AirlineCarrierLoyaltyPartnerships]
};

const AirlineCarriersTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [AirlineCarriersInfoPanel, AirlineCarriersAdminPanel]
};

const AirlineCarrierNameLabel = {dataAt: 'Title', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Title:'};

const AirlineCarriersAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Airline Carrier',
  data: {Title: '', Code: ''},
  dataAt: '',
  children: [AirlineCarrierTitle, AirlineCarrierCode],
  endpoint: 'AirlineCarriers'
};

const AirlineCarriersResource = {
  displayName: 'Airline Carrier',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [AirlineCarrierNameLabel, AirlineCarriersTabs],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId'
};

const AirlineCarriersList = {
  rootNode: true,
  displayName: 'Airline Carriers',
  endpoint: 'AirlineCarriers',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: AirlineCarriersResource,
  gridAdd: AirlineCarriersAddResource,
  iconClass: 'fa-plane',
  gridCols:
    [{name: 'Title', key: 'Title'},
      {name: 'Code', key: 'Code'}]
};

export default {
    AirlineCarriersList,
    AirlineCarriersResource,
    AirlineCarriersAddResource,
    AirlineCarrierNameLabel,
    AirlineCarriersTabs,
    AirlineCarrierTitle,
    AirlineCarrierCode,
    AirlineCarriersInfoPanel,
    AirlineCarriersAdminPanel,
    AirlineCarrierId,
    AirlineCarrierCheckInUrl,
    AirlineCarrierBookableFlightNumbers,
    AirlineCarrierCarrierLogoUrl,
    AirlineCarrierMediumImageUrl,
    AirlineCarrierCountryData,
    AirlineCarrierFareClasses,
    AirlineCarrierFareGdsSettings,
    AirlineCarrierFareRulesDocument,
    AirlineCarrierPartnerAirlines,
    AirlineCarrierLoyaltyPartnerships,
    AirlineCarrierLoyaltyPartnershipsItem,
    AirlineCarrierLoyaltyPartnershipsPartnerCode,
    AirlineCarrierLoyaltyPartnershipsSegmentSpecific,
    AirlineCarrierCreatedBy,
    AirlineCarrierCreatedOn,
    AirlineCarrierModifiedBy,
    AirlineCarrierModifiedOn,
    AirlineCarrierCountryDataGridItem,
    AirlineCarrierFareClassesGridItem,
    AirlineCarrierFareGdsSettingsItem,
    AirlineCarrierCountryDataCountry,
    AirlineCarrierCountryCheckInUrl,
    AirlineCarrierFareClassesTitle,
    AirlineCarrierFareClassesBrandName,
    AirlineCarrierFareClassesBookingCodes,
    AirlineCarrierFareClassesFareBasisCodes,
    AirlineCarrierFareClassesGroupType,
    AirlineCarrierFareClassesCountryFareClass,
    AirlineCarrierFareGdsSettingsName,
    AirlineCarrierFareGdsSettingsPreferredCountries,
    AirlineCarrierFareGdsSettingsFares,
    AirlineCarrierFareClassesCountryFareClassItem,
    AirlineCarrierFareGdsSettingsFaresItem,
    AirlineCarrierFareClassesCountryFareClassCountries,
    AirlineCarrierFareClassesCountryFareClassBrandName,
    AirlineCarrierFareClassesCountryFareClassBookingCodes,
    AirlineCarrierFareClassesCountryFareClassFareBasisCodes,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes,
    AirlineCarrierFareGdsSettingsFaresItemFareData,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItem,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType,
    AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly,
    AirlineCarrierEnableDynamicFareClassification,
    AirlineCarrierEnableMultipleFaresPerFareClass,
    AirlineCarrierBrands,
    AirlineCarrierBrandsBrandItem,
    AirlineCarrierBrandsBrandItemBrandId,
    AirlineCarrierBrandsBrandItemFareClass,
    AirlineCarrierBrandsBrandItemIsBasic,
    AirlineCarrierBrandsBrandItemIsRefundable
}


// WEBPACK FOOTER //
// ./src/config/fields/airlineCarriers.js